export const pageSizes=[10,20,30,50,100,200,300,500,1000];
export const initialpageSize=10;
export const config_ids = [
    { value: "DISCLAIMER", label: "Disclaimer" },
    { value: "MAINTENANCE", label: "Maintenance" },
    { value: "TRANS_MODEL", label: "Transcription GPT Model" },
    { value: "IDEA_MODEL", label: "Get Ideas GPT Model" },
    { value: "QDB_PROMPT_MODEL", label: "QDB Prompts GPT Model" },
    { value: "RAW_MODEL", label: "Raw Answers GPT Model" },
    { value: "REFINED_MODEL", label: "Refined Answers GPT Model" }
];